/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as msRest from "@azure/ms-rest-js";
import * as Models from "../models";
import * as Mappers from "../models/statementsTagMappers";
import { ProfiBazaAPIContext } from "../profiBazaAPIContext";

/** Class representing a StatementsTag. */
export class StatementsTag {
  private readonly client: ProfiBazaAPIContext;

  /**
   * Create a StatementsTag.
   * @param {ProfiBazaAPIContext} client Reference to the service client.
   */
  constructor(client: ProfiBazaAPIContext) {
    this.client = client;
  }

  /**
   * @param [options] The optional parameters
   * @returns Promise<msRest.RestResponse>
   */
  addTag(options?: Models.StatementsTagAddTagOptionalParams): Promise<msRest.RestResponse>;
  /**
   * @param callback The callback
   */
  addTag(callback: msRest.ServiceCallback<void>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  addTag(options: Models.StatementsTagAddTagOptionalParams, callback: msRest.ServiceCallback<void>): void;
  addTag(options?: Models.StatementsTagAddTagOptionalParams | msRest.ServiceCallback<void>, callback?: msRest.ServiceCallback<void>): Promise<msRest.RestResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      addTagOperationSpec,
      callback);
  }

  /**
   * @param [options] The optional parameters
   * @returns Promise<msRest.RestResponse>
   */
  deleteTag(options?: Models.StatementsTagDeleteTagOptionalParams): Promise<msRest.RestResponse>;
  /**
   * @param callback The callback
   */
  deleteTag(callback: msRest.ServiceCallback<void>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  deleteTag(options: Models.StatementsTagDeleteTagOptionalParams, callback: msRest.ServiceCallback<void>): void;
  deleteTag(options?: Models.StatementsTagDeleteTagOptionalParams | msRest.ServiceCallback<void>, callback?: msRest.ServiceCallback<void>): Promise<msRest.RestResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      deleteTagOperationSpec,
      callback);
  }
}

// Operation Specifications
const serializer = new msRest.Serializer(Mappers);
const addTagOperationSpec: msRest.OperationSpec = {
  httpMethod: "POST",
  path: "statements/StatementsTag",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.AddStatementTagCommand
  },
  responses: {
    200: {},
    default: {}
  },
  serializer
};

const deleteTagOperationSpec: msRest.OperationSpec = {
  httpMethod: "DELETE",
  path: "statements/StatementsTag",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.DeleteStatementTagCommand
  },
  responses: {
    200: {},
    default: {}
  },
  serializer
};
